import { FilePlus } from "lucide-react";
import { Helper, Label } from "lumir-back-office-ui";
import { TextDisplay } from "lumir-back-office-ui/RmsTextDisplay";
import { useFormContext } from "react-hook-form";
import { MidLabel } from "./midLabel";
import { useState } from "react";

const FileInput = ({
  className,
  leftIcon,
  error,
  onChange,
  name,
  ...props
}) => {
  const [fileName, setFileName] = useState("파일을 선택해주세요.");
  const { setValue } = useFormContext();

  const handleChange = (e) => {
    const files = e.target.files;
    const file = files?.[0];
    setFileName(file ? file.name : "파일을 선택해주세요.");
    if (files) {
      setValue(name, files);
    }
    onChange?.(e);
  };

  return (
    <label className={`relative inline-flex items-center ${className}`}>
      <input
        type="file"
        className="opacity-0 w-full h-full absolute cursor-pointer z-10"
        accept=".pdf"
        onChange={handleChange}
        {...props}
      />
      <div className="flex items-center gap-sp160 p-sp320">
        <span className="flex items-center justify-center">{leftIcon}</span>
        <span className="typography-semantic-label-1-normal---regular text-semantic-secondary-foreground-inverse-default translate-y-[1px]">
          {fileName}
        </span>
      </div>
      {error && (
        <Helper
          size="md"
          state="error"
          className="typography-semantic-body-2-regular mt-2"
          message={error}
        />
      )}
    </label>
  );
};

const ApplyResume = ({ name }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <section className="space-y-16 mt-[40px]">
      <TextDisplay
        size="lg"
        textData={{
          primary: "제출 서류",
        }}
      />
      <section className="space-y-4">
        <MidLabel label="이력서 및 경력기술서" required />
        <FileInput
          className="w-full h-[46px] rounded-md bg-semantic-secondary-background-strong-default"
          leftIcon={
            <FilePlus className="w-8 h-8 text-semantic-secondary-foreground-strong-default" />
          }
          name={`${name}.resume`}
          {...register(`${name}.resume`)}
        />
        <div></div>
        <Label className="typography-semantic-label-1-normal---regular text-semantic-secondary-foreground-inverse-default">
          * 공통 서류 : 자유 양식의 이력서 및 경력 기술서 (필수) <br /> * 연봉
          정보를 제외하여 PDF 형식으로 제출해 주세요.
        </Label>
        <Helper
          size="md"
          state="error"
          className="typography-semantic-body-2-regular mt-2"
          message={errors[name]?.resume?.message}
        />
      </section>
      <section className="space-y-4">
        <MidLabel label="포트폴리오" />
        <FileInput
          className="w-full h-[46px] rounded-md bg-semantic-secondary-background-strong-default"
          leftIcon={
            <FilePlus className="w-8 h-8 text-semantic-secondary-foreground-strong-default" />
          }
          name={`${name}.portfolio`}
          {...register(`${name}.portfolio`)}
          error={errors[name]?.portfolio?.message}
        />
        <div></div>
        <Label className="typography-semantic-label-1-normal---regular text-semantic-secondary-foreground-inverse-default">
          * 개인 포트폴리오(블로그, 연구 게시물 등)가 있을 경우 첨부
          부탁드립니다. <br /> * PDF 형식으로 제출해 주세요.
        </Label>
      </section>
    </section>
  );
};

export { ApplyResume };
